import { createContext, useContext } from 'react';

interface ChecoutWizardContext {
  countryCode: string;
  setCountryCode: (country: string) => void;
}

const CheckoutWizardContext = createContext<ChecoutWizardContext>({
  countryCode: '',
  setCountryCode: () => {},
});

export const useCheckoutWizardContext = () => {
  const context = useContext(CheckoutWizardContext);
  if (!context) {
    throw new Error('useCheckoutWizardContext must be used within a CheckoutWizardContext');
  }
  return context;
};

export const CheckoutWizardProvider = CheckoutWizardContext.Provider;
